import { __assign, __rest } from "tslib";
import React from 'react';
import Button from '../Button';
export default function ToolbarButton(_a) {
    var children = _a.children, isActive = _a.isActive, props = __rest(_a, ["children", "isActive"]);
    return (React.createElement(Button, __assign({ borderRadius: 1, height: 34, kind: isActive ? 'toolbarActive' : 'toolbar' }, props), children));
}
